import { Component, Inject, OnInit } from '@angular/core';
import { DigisubservicesService } from '../services/digisubservices.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToWords } from 'to-words';
import { ShowBookInvoiceComponent } from '../pages/show-book-invoice/show-book-invoice.component';

@Component({
  selector: 'app-show-book-order',
  templateUrl: './show-book-order.component.html',
  styleUrl: './show-book-order.component.scss'
})
export class ShowBookOrderComponent implements OnInit {
 book;
  bookinvoice;
  // bookinvoice;
  // bokinvoicedata,
  bookinvoicedata;
  total_total = 0;
  shipping_charges_total = 0;
  total_amount = 0;
  shipping_charges = 0;


  totals;
  toWords;
  amtinwords;
  address;

  constructor(
    public service: DigisubservicesService,
    private dialogRef: MatDialogRef<ShowBookInvoiceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data);
  }

  ngOnInit(): void {
    this.book = this.data['book'];
    console.log(this.book['rcpt_id']);
    this.service.getBookOrderForView(this.book['rcpt_id']).subscribe((data) => {
      console.log(data);
      this.bookinvoice = data;
      if (!this.bookinvoice.length) {
        this.dialogRef.close();
        alert('Receipt is not Present.');
      }
    });
    

    this.service.getBookOrderDataForView(this.book['rcpt_id']).subscribe((data) => {
      console.log(data);
      this.bookinvoicedata = data;

      for (
        let index = 0;
        index < Object.keys(this.bookinvoicedata).length;
        index++
      ) {
        this.total_amount =
          this.total_amount + parseInt(this.bookinvoicedata[index]['total']);
        this.shipping_charges =
          this.shipping_charges +
          parseInt(this.bookinvoicedata[index]['shipping_charges']);
      }

      this.totals = this.total_amount + this.shipping_charges;
      this.toWords = new ToWords();
      this.amtinwords = this.toWords.convert(this.totals, {
        currency: true,
      });
    });
    this.address = `${this.bookinvoice[0]['receiver_address']} ${this.bookinvoice[0]['taluka']}, ${this.bookinvoice[0]['district']}, ${this.bookinvoice[0]['state']}, ${this.bookinvoice[0]['country']},  ${this.bookinvoice[0]['pincode']}`;
    console.log(this.address);
  }

  print() {
    window.print();
  }
}
